<template>
  <div>
    <list-page
        :action-buttons="actionButton"
        :actions="actions"
        :columns="columns"
        :descending="true"
        :headers="headers"
        :show-add-button="false"
        :show-default-action-buttons="false"
        :show-invoice-button="true"
        :show-send-mail-template="false"
        icon="mdi-view-list"
        sort="mergedNo"
        stateendpoint="mergedInvoice.mergedInvoices"
        title="Merged Invoice List"
    />
  </div>
</template>

<script>
import ListPage from "@/components/ListPage";

export default {
  name: "MergedInvoiceList",
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - Merged Invoice List | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {ListPage},
  data() {
    return {
      headers: [
        {
          text: 'Method',
          value: 'paymentMethod'
        },
        {
          text: 'Merged No',
          value: 'mergedNo'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Total',
          value: 'totalAmount'
        },
        {
          text: 'Status',
          value: 'paymentStatus'
        },
        {
          text: 'Created Date',
          value: 'createdAt'
        },
        {
          text: 'Ref. Link',
          value: 'mergedRefLink',
          align: 'right',
          sortable: false
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'refcode'},
        {value: 'email'},
        {value: 'price'},
        {value: 'created_at'},
        {value: 'paymentStatus'},
        {value: 'action'}
      ],
      actions: {
        load: 'loadMergedInvoices',
        update: 'updateMergedInvoicePayment',
        remove: 'destroyMergedInvoice',
        softDelete: 'removeMergedInvoice',
        resendMergedMailHandler: 'mergedMailHandler',
        updateMergedMailHandler: 'updateMergedMailHandler',
        refund: 'refundMergedInvoice',
      },
      actionButton: [
        {
          category: 'edit',
          icon: 'mdi-pencil',
          color: '',
          text: 'Edit',
          clickHandler: 'editMergedInvoiceHandler'
        },
        {
          category: 'delete',
          icon: 'mdi-delete-alert',
          color: 'error',
          text: 'Delete',
          clickHandler: 'softDeleteHandler'
        },
        {
          category: 'link',
          icon: 'mdi-eye',
          color: '',
          text: 'View Live Link',
          clickHandler: 'mergedLinkHandler'
        },
        {
          category: 'credit',
          icon: 'mdi-dolly',
          color: '',
          text: 'Make a Manual Payment',
          clickHandler: 'manualMergedPaymentHandler'
        },
        {
          category: 'mergedMail',
          icon: 'mdi-mail',
          color: '',
          text: 'Resend Merged Email',
          clickHandler: 'resendMergedMailHandler'
        },
        {
          category: 'updateMergedMail',
          icon: 'mdi-email-variant',
          color: '',
          text: 'Update Merged Email',
          clickHandler: 'updateMergedMailHandler'
        },
        {
          category: 'refund',
          icon: 'mdi-credit-card-refund',
          color: '',
          text: 'Refund Invoice',
          clickHandler: 'refundInvoiceHandler'
        }
      ]
    }
  },
  mounted() {
    this.$store.dispatch('loadAllAdminUsers');
    this.$store.dispatch('loadAllMethods', {status: false});
  },
}
</script>

<style scoped>

</style>